import React, { useState, useEffect } from 'react';
import {
    Col, Row, FormGroup, Input, Form, Button, Spinner
} from 'reactstrap';
import Select from 'react-select';
import { useForm } from 'react-hook-form';
import MaterialTable from 'material-table';

// Style
import { table_translate, table_style } from "../../../../constants/MaterialTable.js";

// Api
import secaofiscalizacao_api from '../../../../api/secaofiscalizacao_api';
import formulariovistoria_api from '../../../../api/formulariovistoria_api';

// Helpers
import { showMessage, showQuestion } from 'helpers/message.js';

const options_status = [
    { value: "Ativo", label: "Ativo" },
    { value: "Inativo", label: "Inativo" }
];

function initialStateSecao() {
    return {
        identificacao: ""
    }
}

export default function SecoesFiscalizacao({ contrato }) {
    const { register, errors, handleSubmit, setValue } = useForm({ mode: "onBlur" });

    //Estado de controle do loading na tela
    const [show_loading, set_show_loading] = useState(false);

    //Estado de controle da lista de seções do contrato
    const [secoes, set_secoes] = useState([]);

    //Estado de controle do id da seção em edição
    const [secao_id, set_secao_id] = useState(null);

    //Estado de controle do status selecionado
    const [status, set_status] = useState("Ativo");

    //Estado de controle dos formulários vinculados à seção
    const [formularios, set_formularios] = useState([]);

    //Estado de controle das opções de formulários (só os já vinculados ao contrato)
    const [options_formularios, set_options_formularios] = useState([]);

    const handleChangeStatus = (value) => {
        setValue("status", value);
        set_status(value);
    }

    const handleChangeFormularios = (value) => {
        let _formularios = [];
        if (value)
            value.map(m => _formularios.push(m.value));
        set_formularios(_formularios);
    }

    const loadSecoes = () => {
        if (!contrato.contrato_Id) return;
        set_show_loading(true);
        secaofiscalizacao_api.getByContrato(contrato.contrato_Id).then(response => {
            if (response.status !== 200) {
                showMessage("Aviso", response.message, 'error', null);
                return;
            }
            set_secoes(response.data);
        }).finally(f => set_show_loading(false));
    }

    const loadFormularios = () => {
        formulariovistoria_api.getAll(contrato.contrato_Id).then(response => {
            if (response.status !== 200) {
                showMessage("Aviso", response.message, 'error', null);
                return;
            }
            set_options_formularios(response.data.map(value => ({ value: value.formularioVistoria_Id, label: value.identificacao })));
        });
    }

    const loadForm = (secao) => {
        if (secao) {
            setValue("identificacao", secao.identificacao);
            setValue("status", secao.status);
            set_status(secao.status);
            set_formularios(secao.formularioVistoria_Ids ?? []);
        } else {
            setValue("identificacao", "");
            setValue("status", "Ativo");
            set_status("Ativo");
            set_formularios([]);
        }
    }

    const handleVisualizar = (rowData) => {
        set_show_loading(true);
        secaofiscalizacao_api.getItem(rowData.secaoFiscalizacao_Id).then(response => {
            if (response.status !== 200) {
                showMessage("Aviso", response.message, 'error', null);
                return;
            }
            set_secao_id(response.data.secaoFiscalizacao_Id);
            loadForm(response.data);
        }).finally(f => set_show_loading(false));
    }

    const handleExcluir = (rowData) => {
        showQuestion("Atenção", "Tem certeza que quer excluir essa seção de fiscalização?", "question", function (confirmado) {
            if (!confirmado) return;
            set_show_loading(true);
            secaofiscalizacao_api.deleteSecao(rowData.secaoFiscalizacao_Id).then(response => {
                if (response.status !== 200) {
                    showMessage("Aviso", response.message, 'error', null);
                    return;
                }
                showMessage("Sucesso", "Seção de fiscalização excluída com sucesso!", 'success', null);
                loadSecoes();
            }).finally(f => set_show_loading(false));
        });
    }

    const onSubmit = (data) => {
        const json_submit = { ...data };
        json_submit.contrato_Id = contrato.contrato_Id;
        json_submit.formularioVistoria_Ids = [...formularios];

        set_show_loading(true);
        if (secao_id) {
            json_submit.secaoFiscalizacao_Id = secao_id;
            secaofiscalizacao_api.putSecao(json_submit).then(response => {
                if (response.status !== 200) {
                    showMessage("Aviso", response.message, 'error', null);
                    return;
                }
                showMessage("Sucesso", "Seção de fiscalização atualizada com sucesso!", 'success', null);
                loadForm(initialStateSecao());
                set_secao_id(null);
                loadSecoes();
            }).finally(f => set_show_loading(false));
        } else {
            secaofiscalizacao_api.postSecao(json_submit).then(response => {
                if (response.status !== 200) {
                    showMessage("Aviso", response.message, 'error', null);
                    return;
                }
                showMessage("Sucesso", "Seção de fiscalização criada com sucesso!", 'success', null);
                loadForm(initialStateSecao());
                loadSecoes();
            }).finally(f => set_show_loading(false));
        }
    }

    useEffect(() => {
        loadForm();
        loadFormularios();
        loadSecoes();
    }, []);

    return (
        <div>
            {show_loading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Col lg="6" md="12" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Identificação</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="text"
                                name="identificacao"
                                innerRef={register({ required: true })}
                                maxLength={200}
                            />
                            {errors.identificacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="6" md="12" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Status</label>
                            <Select
                                name="status"
                                isDisabled={!secao_id}
                                options={options_status}
                                getOptionLabel={o => o.label}
                                getOptionValue={o => o.value}
                                value={options_status.filter(f => f.value === status)}
                                onChange={(o) => handleChangeStatus(o.value)}
                                classNamePrefix="select"
                                placeholder="[ Selecione ]"
                                ref={e => register(
                                    { name: "status" },
                                    { required: true })
                                }
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="12" md="12" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Formulários vinculados</label>
                            <Select
                                name="formularioVistoria_Ids"
                                options={options_formularios}
                                getOptionLabel={o => o.label}
                                getOptionValue={o => o.value}
                                onChange={(o) => handleChangeFormularios(o)}
                                value={options_formularios.filter((value) => formularios.filter(f => f == value.value).length > 0)}
                                classNamePrefix="select"
                                placeholder="[ Selecione ]"
                                isMulti={true}
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="12" md="12" sm="12" className="text-center">
                        <Button color="success" type="submit">
                            <i className="fas fa-save"></i>  Salvar
                        </Button>
                        <Button type="button" className="ml-2" onClick={() => {
                            loadForm(initialStateSecao());
                            set_secao_id(null);
                        }}>
                            Cancelar
                        </Button>
                    </Col>
                </Row>
            </Form>
            <Form>
                <MaterialTable style={{ minHeight: "auto" }}
                    title=""
                    columns={[
                        { title: 'Identificação', field: 'identificacao' },
                        { title: "Status", field: "status" }
                    ]}
                    data={secoes}
                    isLoading={false}
                    options={{
                        ...table_style,
                        filtering: false,
                        exportButton: true
                    }}
                    actions={[
                        {
                            icon: 'edit',
                            tooltip: 'Editar Registro',
                            onClick: (event, rowData) => handleVisualizar(rowData)
                        },
                        {
                            icon: 'delete',
                            tooltip: 'Excluir Registro',
                            onClick: (event, rowData) => handleExcluir(rowData)
                        }
                    ]}
                    localization={table_translate}
                />
            </Form>
        </div>
    )
}
